import IBSLogo from "../assets/img/IBS_lOGO.png"

export const ImageOnErrorHandler = ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = IBSLogo;
}